import { createSlice } from '@reduxjs/toolkit';
import logger from 'src/analytics/logger';
import {
  IDEA_DETAILS_MODAL,
  MARK_TASK_COMPLETE_MODAL,
  TASK_DETAILS_MODAL
} from '../../RecommendationModalView';

const initialState = {
  isOpen: false,
  activeModal: null,
  recommendationId: null
};

const modals = {
  [MARK_TASK_COMPLETE_MODAL]: 'Task Complete Celebration',
  [IDEA_DETAILS_MODAL]: 'Idea Details',
  [TASK_DETAILS_MODAL]: 'Task Details'
};

const logPageView = (modalViewed, recommendationId) => {
  logger.logPageView('Recommendations', modals[modalViewed], {
    recommendation_id: `RPLUS_${recommendationId}`
  });
};

const modalSlice = createSlice({
  name: 'Modal',
  initialState,
  reducers: {
    setModalOpen(state, action) {
      const { isOpen, activeModal, recommendationId } = action?.payload;
      if (!isOpen) {
        state.activeModal = null;
        state.recommendationId = null;
        state.isOpen = isOpen;
        return;
      }

      logPageView(action.payload.activeModal, recommendationId);
      state.isOpen = isOpen;
      state.activeModal = activeModal;

      if (recommendationId) {
        state.recommendationId = recommendationId;
      }
    }
  }
});

export const { setModalOpen } = modalSlice.actions;

export const selectModalState = (state) => state.modal;

export default modalSlice.reducer;
